import React, { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // Hook i18next
import logoWelding from "../../imagens/logos/logoSoldagens.png";
import logoWeldingsEn from "../../imagens/logos/logoWeldingsEn.png";
import "./weldingCapabilities.css";

function WeldingsCapabilities({ listWelding }) {
  const { i18n, t } = useTranslation();
  const [slideNumber, setSlideNumber] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  const logoImg = i18n.language === "en" ? logoWeldingsEn : logoWelding;

  const handleOpenModal = (index) => {
    setSlideNumber(index);
    setOpenModal(true);
  }

  const handleCloseModal = () => {
    setOpenModal(false);
  }

  const prevSlide = useCallback(() => {
    slideNumber === 0 ?
      setSlideNumber(listWelding.length - 1) :
      setSlideNumber(slideNumber - 1);
  }, [slideNumber, listWelding.length]);

  const nextSlide = useCallback(() => {
    slideNumber + 1 === listWelding.length ?
      setSlideNumber(0) :
      setSlideNumber(slideNumber + 1);
  }, [slideNumber, listWelding.length]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      switch (event.key) {
        case 'Escape':
          handleCloseModal();
          break;
        case 'ArrowLeft':
          prevSlide();
          break;
        case 'ArrowRight':
          nextSlide();
          break;
        default:
          break;
      }
    };

    if (openModal) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [openModal, nextSlide, prevSlide]);

  return (
    <div>
      {openModal &&
        <div className='weldSliderWrap'>
          <FontAwesomeIcon icon={faCircleChevronLeft} className='weldBtnPrev' onClick={prevSlide} />
          <FontAwesomeIcon icon={faCircleChevronRight} className='weldBtnNext' onClick={nextSlide} />
          <FontAwesomeIcon icon={faCircleXmark} className='weldBtnClose' onClick={handleCloseModal} />
          <img className='weldFullScreenImage' src={listWelding[slideNumber].img} alt="FullScreenImage" />
        </div>
      }

      <div className='img-custom-size img-fluid ms-2'>
        <img src={logoImg} alt='Welding Logo' />
      </div>

      <div className='weldGalleryWrap mx-2'>
        {listWelding && listWelding.map((image, index) => (
          <div className='weldSingle' key={index} onClick={() => handleOpenModal(index)}>
            <img src={image.img} alt="welding" />
          </div>
        ))}
      </div>

      <div className="text-center text-nowrap my-4">
        <Link to="/Capabilities/Production">
          <button className="buttonCapabilities">
            {t("weldings.backToCapabilities")}
          </button>
        </Link>
      </div>
    </div>
  )
}

export default WeldingsCapabilities;
